import { Fragment } from 'react'

import { imageUrl } from 'app/frontend/base/helpers'
import { raidMarkerTypes } from 'app/frontend/types/custom/RaidMarker'

const markerTokenPattern = /\{([a-z]+)\}/g

type MarkerTextPart =
  | { type: 'text'; value: string }
  | { type: 'marker'; value: string }

export const parseMarkerText = (text: string): MarkerTextPart[] => {
  const parts: MarkerTextPart[] = []
  let lastIndex = 0
  let match = markerTokenPattern.exec(text)

  while (match) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: text.slice(lastIndex, match.index) })
    }
    const marker = match[1]
    if (raidMarkerTypes.includes(marker as typeof raidMarkerTypes[number])) {
      parts.push({ type: 'marker', value: marker })
    } else {
      parts.push({ type: 'text', value: match[0] })
    }
    lastIndex = match.index + match[0].length
    match = markerTokenPattern.exec(text)
  }

  if (lastIndex < text.length) {
    parts.push({ type: 'text', value: text.slice(lastIndex) })
  }

  return parts
}

type Props = {
  text: string
  markerClassName?: string
}

const MarkerText = ({
  text,
  markerClassName = 'inline-block h-3.5 w-3.5 shrink-0 align-middle',
}: Props) => (
  <>
    {parseMarkerText(text).map((part, index) =>
      part.type === 'marker' ? (
        <img
          key={`${part.value}-${index}`}
          src={imageUrl(`markers/${part.value}.png`)}
          className={markerClassName}
        />
      ) : (
        <Fragment key={index}>{part.value}</Fragment>
      ),
    )}
  </>
)

export default MarkerText
